import ReactDOM from 'react-dom';
import { ua } from '../ua';
import { weappSDK } from '../sdk';
import request, { RequestOptionConfig } from '../request';

export function showImage(params: any) {
  const { data, photoIndex = 0, otherParams } = params;
  // data: Array<PhotoViewData>, photoIndex?: number, otherParams?: PhotoViewProps
  const isMobile = ua.device === 'Mobile';

  const div = document.createElement('div');
  document.body.appendChild(div);

  function handleClose() {
    ReactDOM.unmountComponentAtNode(div);
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
  };

  const PhotoViewCom = isMobile ? window.weappUi.MPhotoView : window.weappUi.PhotoView;

  ReactDOM.render(<PhotoViewCom
    weId={`liwxm8`}
    data={data}
    visible={true}
    onClose={handleClose}
    photoIndex={photoIndex}
    {...otherParams}
  />, div);

  return {
    close: handleClose,
  }
}


export function showVideo(params: any) {
  const { url, otherParams } = params;
  // url?: string, otherParams?: VideoProps

  const isMobile = ua.device === 'Mobile';
  if (isMobile) {
    weappSDK.openLink({ url });
  }

  const div = document.createElement('div');
  document.body.appendChild(div);

  function handleClose() {
    ReactDOM.unmountComponentAtNode(div);
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
    otherParams?.onClose?.()
  };

  const VideoCom = window.weappUi?.Video;

  ReactDOM.render(<VideoCom weId={`liveox`}
    controls
    src={url}
    {...otherParams}
    dialogProps={{
      visible: true
    }}
    isDialog
    onClose={handleClose}
  />, div);

  return {
    close: handleClose,
  }
}


export function showAudio(params: any) {
  const { url, otherParams } = params;
  // url?: string, otherParams?: AudioProps

  const isMobile = ua.device === 'Mobile';
  if (isMobile) {
    weappSDK.openLink({ url: url });
  }

  const div = document.createElement('div');
  document.body.appendChild(div);

  function handleClose() {
    ReactDOM.unmountComponentAtNode(div);
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
    otherParams?.onClose?.()
  };
  
  const AudioCom = window.weappUi?.Audio;
  const render = () => {
    ReactDOM.render(<AudioCom
      weId={`liveox`}
      controls
      src={url}
      {...otherParams}
      dialogProps={{ visible: true }}
      isDialog
      onClose={handleClose}
    />, div);
  };
  render();

  return {
    close: handleClose,
  }
}

export function previewRequest(option: RequestOptionConfig) {
  const isMobile = ua.device === 'Mobile';
  const options: RequestOptionConfig = {
    url: `/api${isMobile ? '/app' : ''}/file/preview`,
    method: 'GET',
    ...option
  };
  return request(options);
}

/**
 * 图片预览功能
 * @param params AnyObj
 */
 export const imagePreview = (params: {
  fileIds: string[],
  fileId: string,
  onSuccess?: (images: any, fIndex: number) => void,
  onError?: (e?: Event) => void,
}) => {
  const { fileIds, fileId, onError, onSuccess } = params;
  let images: any[] = [];
  let fIndex = -1;
  let allReqPre = fileIds.map(item => previewRequest({ params: { fileId: item } }));
  Promise.all(allReqPre)
    .then(datas => {
      datas.forEach((item: any, index: number) => {
        if (item.code === 200) {  // 预览接口返回正常
          if (fileIds[index] === fileId) {
            fIndex = index;
          }
          images.push({
            id: fileIds[index],
            src: item.data.loadUrl
          })
        } else {  // 当前预览图片异常
          onError?.();
        }
      })
      // 图片预览
      fIndex !== -1 && onSuccess?.(images, fIndex)
    })
    .catch(err => {
      onError?.(err);
    })
}

/**
 * 其他文件统一预览方法（包括 excel、word 等非 upload 内部处理预览的文件）
 * @param params anyObj
 */
 export const otherFilePreiver = (params: {
  previewLink: string,
  loadUrl: string,
  previewType: string,
  onError: () => void;
}) => {
  const { previewLink, loadUrl, previewType, onError } = params;
  if (previewLink || loadUrl) {
    /**
     * 预览类型。
     * 当值为 load 时，取 loadUrl 下载地址的值，下载文件进行预览处理，一般为图片、视频、音频文件，通过下载地址调用播放组件进行处理。
     * 当值为 link 时，取 previewLink 地址进行请求跳转。
     * 当值为 origin 时，previewLink 返回的时请求 url 需要拼接当前环境的域名进行请求，进行预览。
     */
    let url = '';
    switch (previewType) {
      case 'load':
        url = loadUrl
        break;
      case 'link':
        url = previewLink
        break;
      case 'origin':
        url = window.origin + previewLink
        break;
      default:
        break;
    }
    // 其他（excel、word 等）
    // 这里调用打开链接方法
    window.open(url);
  } else {
    onError?.();
  }
}